import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { IconLinks } from "../../sharedComponents/IconLinks";
import * as styles from "./IconLinks.module.scss";

const IconLinksChecks = ({ links }) => (
	<div>
		<div className="row">
			{links.map(item => (
				<div key={item.id}>
					<IconLinks
						layout="row"
						className={cx(styles.item, styles.checkItem)}
						to={item?.link?.url}
						target={item.link.target}>
						<IconLinks.Icon icon={item.icon} className={styles.checkIcon} />
						<IconLinks.Content className={cx(styles.link, styles.checkLink)}>
							{item.link.linkText}
						</IconLinks.Content>
					</IconLinks>
				</div>
			))}
		</div>
	</div>
);

IconLinksChecks.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			icon: PropTypes.shape({
				svg: PropTypes.shape({
					content: PropTypes.string,
				}),
				link: PropTypes.shape({
					to: PropTypes.string.isRequired,
					target: PropTypes.string,
				}),
			}).isRequired,
		})
	).isRequired,
};

export default IconLinksChecks;
export { IconLinksChecks };
